export function getTextFromHTML(_ref) {
  var input = _ref.input;
  return extract(input);
}
function extract(str) {
  return str.replace(/(<([^>]+)>)/gi, "");
}